import React from "react";
import Header from "./header/Header";
import Landing from "./landing/Landing";
import Statistics from "./statistics/Statistics";
import Features from "./features/Features";
import TopButton from "./topbutton/TopButton";
import Footer from "./footer/Footer";

const Home = () => {

    return(
        <div className="home-container">
            <Landing />
            <Features />
            <Footer />
            <TopButton />
        </div>
    )
}

export default Home;